// src/pages/ReportsPage.tsx — Reports & Analytics (all working)
import React, { useState } from 'react';
import { getDeliveryReport, getFraudReport, getSubsidyReport, QueryParams } from '../services/api';
import type { AxiosResponse } from 'axios';

type ReportFetcher = (params?: QueryParams) => Promise<AxiosResponse<Blob>>;

export default function ReportsPage() {
  const [busy, setBusy] = useState('');

  const download = async (key: string, fn: ReportFetcher, filename: string) => {
    setBusy(key);
    try {
      const r   = await fn({ format: 'excel' });
      const url = URL.createObjectURL(new Blob([r.data]));
      const a   = document.createElement('a');
      a.href = url; a.download = filename; a.click();
      setTimeout(() => URL.revokeObjectURL(url), 1000);   // revoking immediately can cancel the download
    } catch {
      alert('Could not download report — is the backend running?');
    } finally {
      setBusy('');
    }
  };

  const cards = [
    { key:'delivery', icon:'📥', title:'Delivery Report',         desc:'State / district / date-wise delivery data of every bag.', btn:'Download Excel', color:'var(--g2)',   fn:getDeliveryReport, file:'delivery_report.xlsx' },
    { key:'fraud',    icon:'🚨', title:'Fraud Summary',           desc:'All fraud alerts — duplicates, velocity, location mismatch.', btn:'Download Excel', color:'var(--red)',  fn:getFraudReport,    file:'fraud_report.xlsx' },
    { key:'subsidy',  icon:'💰', title:'Subsidy Reconciliation',  desc:'Delivered bags matched to their subsidy amounts (paid/unpaid).', btn:'Download Excel', color:'var(--blue)', fn:getSubsidyReport,  file:'subsidy_report.xlsx' },
  ];

  return (
    <>
      <div className="topbar"><div className="topbar-title">📊 Reports & Analytics</div></div>
      <div className="page-content fade-in">
        <div className="grid-3">
          {cards.map(c => (
            <div key={c.key} className="card" style={{ textAlign:'center', display:'flex', flexDirection:'column' }}>
              <div style={{ fontSize:36, marginBottom:12 }}>{c.icon}</div>
              <h3 style={{ marginBottom:8 }}>{c.title}</h3>
              <p style={{ fontSize:13, marginBottom:16, flex:1 }}>{c.desc}</p>
              <button
                className="btn btn-primary"
                style={{ background:c.color, boxShadow:`0 3px 12px ${c.color}44`, justifyContent:'center' }}
                onClick={() => download(c.key, c.fn, c.file)}
                disabled={busy === c.key}
              >
                {busy === c.key ? <><span className="spin">⟳</span> Generating…</> : <>⬇️ {c.btn}</>}
              </button>
            </div>
          ))}
        </div>

        <div className="card" style={{ marginTop:16 }}>
          <div className="card-title">About these reports</div>
          <div style={{ fontSize:12, color:'var(--ink3)', lineHeight:1.8 }}>
            • <strong>Delivery Report</strong> — every delivered bag with farmer, dealer, GPS and date.<br/>
            • <strong>Fraud Summary</strong> — all flagged cases with type, severity and dealer.<br/>
            • <strong>Subsidy Reconciliation</strong> — total subsidy due/paid per delivered bag, for accounting.<br/>
            All reports download as Excel (.xlsx) and reflect live database data.
          </div>
        </div>
      </div>
    </>
  );
}
